import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
  AlertTitle,
  Box,
  Link,
  Typography,
} from '@mui/material'
import WarningIcon from '@mui/icons-material/Warning'
import { useNavigate } from 'react-router-dom'

interface DuplicateWarningProps {
  open: boolean
  supplierName: string
  rechnungsnummer: string
  dateInvoice?: string | null
  duplicateId?: string | null
  onConfirm: () => void
  onCancel: () => void
}

export function DuplicateWarning({
  open,
  supplierName,
  rechnungsnummer,
  dateInvoice,
  duplicateId,
  onConfirm,
  onCancel,
}: DuplicateWarningProps) {
  const navigate = useNavigate()

  const handleViewExisting = () => {
    if (duplicateId) {
      navigate(`/database?invoice=${duplicateId}`)
    } else {
      navigate('/database')
    }
    onCancel()
  }

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningIcon color="warning" />
          <Typography variant="h6">Potenzielle doppelte Rechnung</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning">
          <AlertTitle>Achtung</AlertTitle>
          <Typography variant="body2">
            Eine Rechnung mit denselben Daten existiert bereits:
          </Typography>
          <Box component="ul" sx={{ mt: 1, mb: 0, pl: 2 }}>
            <Typography component="li" variant="body2">
              <strong>Lieferant:</strong> {supplierName}
            </Typography>
            <Typography component="li" variant="body2">
              <strong>Rechnungsnummer:</strong> {rechnungsnummer}
            </Typography>
            {dateInvoice && (
              <Typography component="li" variant="body2">
                <strong>Datum:</strong> {dateInvoice}
              </Typography>
            )}
          </Box>
        </Alert>
        <Box sx={{ mt: 2 }}>
          <Link
            component="button"
            variant="body2"
            onClick={handleViewExisting}
            underline="hover"
          >
            Vorhandene Rechnung anzeigen
          </Link>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Abbrechen
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          Trotzdem speichern
        </Button>
      </DialogActions>
    </Dialog>
  )
}
